import { useEffect } from 'react';
import checkIllustration from '../../assets/inquiry1.png';
import dividerIllustration from '../../assets/inquiry2.png';

const InquirySuccessPage = () => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.location.assign('/');
      }
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="inquiry-success">
      <section className="success-card">
        <div className="success-badge">
          <img src={checkIllustration} alt="Inquiry submitted" />
        </div>
        <h1>Thank you!</h1>
        <p>
          Your inquiry has been submitted. We&apos;ll get back to you shortly with the details.
        </p>
        <img
          src={dividerIllustration}
          alt=""
          className="success-divider-image"
        />
        <p className="success-note">You will be redirected shortly.</p>
      </section>
    </div>
  );
};

export default InquirySuccessPage;
